import { Injectable } from '@angular/core';
import {HeroHostService} from "lib-hero";
import {BooxSessionService} from "lib-boox";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class BootService {

  constructor(
    private app : HeroHostService,
    private session: BooxSessionService,
    private router : Router,
  ) { }

  async load() {
    this.app.update('guest.app.auto_start', true);
    this.app.update('guest.app.auto_user', true);
    this.app.boot();

    // this.notification.notifications.subscribe((notification : INotification[]) => {
    //     console.log(notification);
    // });

    // check if the session is valid and redirect to the login page if not
    // but only if the user is not already on the login page
    let hasSession : boolean = !!this.session.session;
    this.session.$valid.subscribe((valid) => {
      let redirect = hasSession && !valid;
      hasSession = valid;
      if(redirect) this.router.navigate(['/', 'sign-in']);
    });
    await Promise.resolve();
  }
}
